import { ErknmKnmDocumentTypeCodesEnum } from 'APIPackage/CatalogsModule/enums/ErknmKnmDocumentTypeCodesEnum';

export const clippedKnmDocumentTypes: string[] = [
  ErknmKnmDocumentTypeCodesEnum.VP_V,
  ErknmKnmDocumentTypeCodesEnum.AP_I,
  ErknmKnmDocumentTypeCodesEnum.AP_II,
  ErknmKnmDocumentTypeCodesEnum.AP_III,
  ErknmKnmDocumentTypeCodesEnum.AP_IV,
  ErknmKnmDocumentTypeCodesEnum.AP_V,
  ErknmKnmDocumentTypeCodesEnum.PP_0,
  ErknmKnmDocumentTypeCodesEnum.PP_I,
  ErknmKnmDocumentTypeCodesEnum.PP_II,
  ErknmKnmDocumentTypeCodesEnum.PP_III,
  ErknmKnmDocumentTypeCodesEnum.PP_IV,
  ErknmKnmDocumentTypeCodesEnum.PP_V,
  ErknmKnmDocumentTypeCodesEnum.PP_VI,
  ErknmKnmDocumentTypeCodesEnum.PP_VII,
  ErknmKnmDocumentTypeCodesEnum.PP_VIII,
  ErknmKnmDocumentTypeCodesEnum.PP_IX,
  ErknmKnmDocumentTypeCodesEnum.PP_X,
  ErknmKnmDocumentTypeCodesEnum.PP_XI,
  ErknmKnmDocumentTypeCodesEnum.PP_XII,
  ErknmKnmDocumentTypeCodesEnum.PP_XIII,
];
